import { ApiClient } from '../../global.d';
import { COOKIES } from '../constants/cookies';
import { getCookie } from '../utils/cookies';

const ListAppService = async () => {
  return new ApiClient({
    baseURL: process.env.REACT_APP_LIST_HOST,

    headers: {
      authenticationToken: getCookie(COOKIES.AUTH_TOKEN)
    }
  });
};

export default ListAppService;
